import { TimeUnit } from 'generated/graphql';

export const getAggregatePeriodLabel = (aggregatePeriod?: TimeUnit) => {
  switch (aggregatePeriod) {
    case TimeUnit.Day:
      return 'day';
    case TimeUnit.Week:
      return 'week';
    case TimeUnit.Month:
      return 'month';
    default:
      return 'day';
  }
};
